<template>
  <div>
    <div class="page-title">
      <h3 class="planning_title">{{'Menu_Planning' | localize}}</h3>
      <h4 class="planning_title">{{bill | currency('UAH')}}</h4>
    </div>

    <Loader v-if="loading" />

    <p class="center" v-else-if="!categories.length">
      {{'NoCategories' | localize}}.
      <router-link to="/categories">{{'AddCategory' | localize}}</router-link>
    </p>

    <section v-else>
      <div v-for="cat in categories" :key="cat.id">
        <p>
          <strong>{{cat.title}}:</strong>
          {{cat.spend | currency}} {{'Of' | localize}} {{cat.limit | currency}}
        </p>
        <div class="cont" v-tooltip.noloc="toolFn(cat.spend, cat.limit)">
          <div class="progress">
            <div
              class="determinate"
              :class="[cat.progressColor]"
              :style="{width: cat.progressPercent + '%'}"
            ></div>
          </div>
          <button
            class="btn-floating btn-small waves-effect waves-light red"
            type="button"
            @click.prevent="categoryDelete(cat.id)"
          >
            <i class="material-icons">delete</i>
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
.progress {
  margin-top: 15px;
}
.cont {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.btn-small {
  width: 39.5px !important;
  height: 36px !important;
  margin-left: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
}

.planning_title {
  font-size: 28px;
  transition: all 0.2s linear;
}

@media screen and (max-width: 425px) {
  .btn-small {
    width: 44px !important;
    height: 36px !important;
  }

  .planning_title {
    font-size: 20px;
    transition: all 0.2s linear;
  }
}
</style>

<script>
import currencyFilter from "@/filters/currency.filter";
import localizeFilter from "@/filters/localize.filter";

export default {
  name: "Planning",
  metaInfo() {
    return {
      title: this.$title("Menu_Planning")
    };
  },
  data: () => ({
    loading: true,
    categories: [],
    records: []
  }),
  computed: {
    bill() {
      return this.$store.getters.info.bill;
    }
  },
  async mounted() {
    this.records = await this.$store.dispatch("fetchRecords");
    const categories = await this.$store.dispatch("fetchCategories");

    this.categories = categories.map(cat => {
      const spend = this.records
        .filter(r => r.categoryId === cat.id)
        .filter(r => r.type === "outcome")
        .reduce((total, record) => {
          return (total += +record.amount);
        }, 0);

      const percent = (100 * spend) / cat.limit;
      const progressPercent = percent > 100 ? 100 : percent;
      const progressColor =
        percent < 60 ? "green" : percent < 100 ? "yellow" : "red";
      return {
        ...cat,
        progressPercent,
        progressColor,
        spend
      };
    });

    this.loading = false;
  },
  methods: {
    toolFn(spend, limit) {
      if (spend < limit) {
        return `${localizeFilter("Stayed")} : ${currencyFilter(limit - spend)}`;
      } else if (spend > limit) {
        return `${localizeFilter("MoreThan")} : ${currencyFilter(
          spend - limit
        )}`;
      }
    },
    async categoryDelete(categoryId) {
      this.loading = true;
      const need = this.records.filter(r => r.categoryId === categoryId);

      const recordsId = need.map(rec => {
        return rec.id;
      });

      await this.$store.dispatch("deleteCategory", { categoryId, recordsId });
      const categories = await this.$store.dispatch("fetchCategories");
      this.categories = categories.map(cat => {
        const spend = this.records
          .filter(r => r.categoryId === cat.id)
          .filter(r => r.type === "outcome")
          .reduce((total, record) => {
            return (total += +record.amount);
          }, 0);

        const percent = (100 * spend) / cat.limit;
        const progressPercent = percent > 100 ? 100 : percent;
        const progressColor =
          percent < 60 ? "green" : percent < 100 ? "yellow" : "red";
        return {
          ...cat,
          progressPercent,
          progressColor,
          spend
        };
      });
      this.loading = false;
    }
  }
};
</script>